import Image from 'next/image'
import { Project } from '../types/project'
import { useMemo } from 'react'

interface ProjectImageProps {
  image: string
  project: Project
  aspectRatio?: string
  sizes?: string
  blur?: string
  rounded?: boolean
  imagesCount?: number
}

export const ProjectImage = ({
  image,
  project,
  aspectRatio = '255/225',
  sizes,
  rounded,
  imagesCount,
}: ProjectImageProps) => {
  const imageSize = useMemo(() => {
    if (sizes) return sizes

    if (imagesCount === 1) {
      return '(max-width: 599px) 90vw, (max-width: 1023px) 80vw, (max-width: 1079px) 1152, 310px'
    }

    return '(max-width: 599px) 90vw, (max-width: 1023px) 45vw, (max-width: 1079px) 418px, 310px'
  }, [imagesCount, sizes])

  return (
    <div
      style={{
        aspectRatio: aspectRatio,
        overflow: 'hidden',
        backgroundColor: 'rgb(0, 0, 0)',
        borderRadius: rounded ? '10px' : '',
      }}
      className="relative"
    >
      <div
        className="z-1 absolute top-0 left-0 right-0 bottom-0"
        style={{
          position: 'absolute',
          width: '10%',
          height: '10%',
          filter: 'blur(2px)',
          left: '45%',
          top: '45%',
          transform: 'scale(11)',
          opacity: 0.4,
        }}
      >
        {image && (
          <Image
            src={image}
            alt={'project_gallery_blur' + project?.id + '_'}
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
  
              position: 'absolute',
            }}
            className="rounded-t-6"
            // blurDataURL={image}
            sizes={imageSize}
            fill
          />
        )}
      </div>
      <Image
        src={image}
        alt={'project_gallery_' + project?.id + '_'}
        style={{ objectFit: 'contain', objectPosition: 'center' }}
        className="rounded-t-6 z-2"
        sizes={imageSize}
        fill
      />
    </div>
  )
}
